import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import { HiMiniPencilSquare } from "react-icons/hi2";
import { FaBars } from "react-icons/fa";
import FalconLogo from "../../assets/owl.png";
import { useMsal } from "@azure/msal-react";
import Select from "react-select";
import axiosClient from "../../api-client/AxiosClient";

const Header = ({ isOpen, setIsOpen, run, setRun }) => {
  const { Dashboard, DataSource, Upload, STTMapping, Administration } =
    JSON.parse(sessionStorage.getItem("rolesAndPermission") || "{}");

  const { instance } = useMsal();
  const menuRef = useRef(null);
  const [corporationDropdown, setCorporationDropdown] = useState();
  const [corporationList, setCorporationList] = useState([]);
  const [showOrganizationPopup, setShowOrganizationPopup] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [steps, setSteps] = useState([
    {
      target: ".header-icon-joyride-class",
      content:
        "Falcon Mapping delivers discipline, intelligence, and simplicity to data migration and reporting, turning a traditionally complex and error-prone process into a streamlined, dependable solution for enterprises.",
      disableBeacon: true,
    },
    {
      target: ".header-corporation-joyride-class",
      content:
        "Seamlessly switch between all organizations you have access to across the platform.",
      disableBeacon: true,
    },
    {
      target: ".header-profile-joyride-class",
      content:
        "Access your account, manage profile settings, and log out across the platform.",
      disableBeacon: true,
    },
  ]);

  useEffect(() => {
    let newSteps = [...steps];
  
    if (Dashboard?.canView) {
      newSteps.push(
        {
          target: ".sidebar-dashboard-joyride-class",
          content:
            "Track overall mapping progress, review system warnings, and monitor completion status across objects and users.",
          disableBeacon: true,
          placement: "right",
        },
      );
    }
    if (DataSource?.canView) {
      newSteps.push(
        {
          target: ".sidebar-datasource-joyride-class",
          content:
            "Connect to multiple data sources and seamlessly configure, manage, and validate source and target system connections.",
          disableBeacon: true,
          placement: "right",
        },
      );
    }
    if (Upload?.canView) {
      newSteps.push(
        {
          target: ".sidebar-upload-joyride-class",
          content:
            "Upload partially or fully prepared mapping documents for target system objects, with guidance on supported formats and validation.",
          disableBeacon: true,
          placement: "right",
        },
      );
    }
    if (STTMapping?.canView) {
      newSteps.push(
        {
          target: ".sidebar-stt-joyride-class",
          content:
            "Access existing mapping documents to complete, validate, and refine source-to-target field mappings, supported by intelligent suggestions and error highlights.",
          disableBeacon: true,
          placement: "right",
        },
      );
    }
    newSteps.push(
      {
        target: ".sidebar-ai-joyride-class",
        content:
          "Engage with Bluegecko's AI-powered assistant to quickly locate relevant mappings, ask questions, and receive contextual recommendations.",
        disableBeacon: true,
        placement: "right",
      },
    );
    if (Administration?.canView) {
      newSteps.push(
        {
          target: ".sidebar-settings-joyride-class",
          content:
            "Admin Settings provides centralized control over key system configurations. It allows you to manage users and roles, configure organizational settings, and define objects and templates to maintain consistency in mapping and reporting",
          disableBeacon: true,
          placement: "right",
        },
      );
    }

    setSteps(newSteps);
  }, []);

  const toggleDropdown = () => setIsMenuOpen(!isMenuOpen);

  const handleLogout = () => {
    instance.logout().catch((e) => {
      console.error(e);
    });
  };

  const handleCorporationSelect = async (selected) => {
    if (corporationDropdown?.value === selected?.value) {
      return;
    }
    setCorporationDropdown(selected);
    localStorage.setItem("selectedCorporation", JSON.stringify(selected));
    window.dispatchEvent(new Event("localStorageUpdated"));

    // Dispatch custom event for same-window communication
    window.dispatchEvent(
      new CustomEvent("customStorageChange", {
        detail: {
          key: "selectedCorporation",
          newValue: JSON.stringify(selected),
        },
      })
    );
  };

  const handleEditOrganization = () => {
    setShowOrganizationPopup(true);
  };

  const handlePopupCorporationChange = (selected) => {
    handleCorporationSelect(selected);
    setShowOrganizationPopup(false);
  };

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("popup-overlay")) {
      setShowOrganizationPopup(false);
    }
  };

  useEffect(() => {
    setLoggedInUser(
      JSON.parse(
        sessionStorage.getItem(
          JSON.parse(sessionStorage.getItem("msal.account.keys"))[0]
        )
      ).name.split(" ")
    );
  }, []);

  useEffect(() => {
    const fetchCorporations = async () => {
      const response = await axiosClient.get(
        "/api/corporation/GetUserCorporations"
      );
      if (response && response.data) {
        const data = Array.isArray(response.data) ? response.data : [];
        const formatted = data.map((corp) => ({
          label: corp.name,
          value: corp.corporationId,
        }));
        setCorporationList(formatted);

        // Check if there's already a stored corporation
        const storedCorporation = localStorage.getItem("selectedCorporation");
        if (storedCorporation) {
          setCorporationDropdown(JSON.parse(storedCorporation));
        } else if (formatted.length > 0) {
          // Set first corporation as default
          setCorporationDropdown(formatted[0]);
          localStorage.setItem(
            "selectedCorporation",
            JSON.stringify(formatted[0])
          );
          window.dispatchEvent(new Event("localStorageUpdated"));
        }
      } else {
        setCorporationList([]);
      }
    };
    fetchCorporations();
  }, []);

  return (
    <>
      <header className="header">
        <div className="left-section">
          <button className="sidebar-toggle" onClick={() => setIsOpen(!isOpen)}>
            <FaBars />
          </button>

          <div className="flex items-center header-icon-joyride-class">
            <img src={FalconLogo} alt="NextGenlytics Logo" className="logo" />
          </div>
        </div>
        <div style={{ marginLeft: "40px", fontSize: "14px", color: "#6b7280" }}>
          <span> BlueGecko / Owl Sight</span>
        </div>

        <div
          className="relative w-full max-w-md mx-auto invisible"
          style={{ fontSize: "14px", color: "#6b7280" }}
        >
          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1117.5 10a7.5 7.5 0 01-4.85 6.65z"
              />
            </svg>
          </span>
          <input
            type="text"
            placeholder="Search objects, modules & mapping progress"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 text-sm text-gray-700"
          />
        </div>
        <div className="user-info">
          {window.location.pathname !== "/admin-interface" && (
            <>
              {corporationDropdown && (
                <div
                  className="organization-hover-container"
                  onClick={
                    corporationList?.length > 1
                      ? handleEditOrganization
                      : undefined
                  }
                  style={{
                    cursor: corporationList?.length > 1 ? "pointer" : "default",
                  }}
                >
                  <span
                    className="organization-name header-corporation-joyride-class"
                    style={{ fontSize: "14px", color: "#6b7280" }}
                  >
                    {corporationDropdown.label}
                  </span>
                  {corporationList?.length > 1 && (
                    <span className="edit-organization-btn">
                      <HiMiniPencilSquare />
                    </span>
                  )}
                </div>
              )}
              <div className="separator-line"></div>
            </>
          )}
          <div className="relative" ref={menuRef}>
            {/* Avatar Button */}
            <span
              onClick={toggleDropdown}
              className="flex items-center justify-center w-10 h-10 rounded-full bg-yellow-500 text-white font-bold cursor-pointer header-profile-joyride-class"
            >
              {loggedInUser[0]?.charAt(0)}
              {loggedInUser.length > 1 &&
                loggedInUser[loggedInUser.length - 1]?.charAt(0)}
            </span>

            {/* Dropdown */}
            {isMenuOpen && (
              <div className="absolute right-0 mt-2 w-auto bg-white rounded-lg shadow-xl border z-50">
                {/* Header */}
                <div className="flex items-center justify-between px-4 py-3 border-b">
                  <span className="font-semibold text-gray-800">BlueGecko</span>
                  <button
                    onClick={handleLogout}
                    className="text-sm text-blue-600 hover:underline"
                  >
                    Sign out
                  </button>
                </div>

                {/* Profile Info */}
                <div className="flex items-center gap-[12px] px-4 py-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500 text-white font-bold">
                    {loggedInUser[0]?.charAt(0)}
                    {loggedInUser.length > 1 &&
                      loggedInUser[loggedInUser.length - 1]?.charAt(0)}
                  </div>
                  <div className="flex flex-col">
                    <span className="font-medium text-gray-900">
                      {loggedInUser[0]}{" "}
                      {loggedInUser.length > 1 &&
                        loggedInUser[loggedInUser.length - 1]}
                    </span>
                    <span className="text-sm text-gray-600">
                      {JSON.parse(
                        sessionStorage.getItem(
                          JSON.parse(
                            sessionStorage.getItem("msal.account.keys")
                          )[0]
                        )
                      ).username || ""}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Organization Selection Popup */}
      {showOrganizationPopup && (
        <div className="popup-overlay" onClick={handleOutsideClick}>
          <div className="popup-content">
            <h3 className="popup-title">Select Organization</h3>
            <div className="popup-body">
              <Select
                value={corporationDropdown}
                onChange={handlePopupCorporationChange}
                options={corporationList}
                placeholder="Select Corporation"
                isSearchable
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    minHeight: "40px",
                    borderColor: state.isFocused ? "#3B82F6" : "#D1D5DB",
                    boxShadow: state.isFocused ? "0 0 0 1px #3B82F6" : "none",
                    "&:hover": {
                      borderColor: "#9CA3AF",
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected
                      ? "#3B82F6"
                      : state.isFocused
                      ? "#EFF6FF"
                      : "white",
                    color: state.isSelected ? "white" : "#374151",
                    "&:hover": {
                      backgroundColor: state.isSelected ? "#3B82F6" : "#EFF6FF",
                    },
                  }),
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
